import { handleAdminParentQDUpdated } from "./admin"
import { handleUserParentQDUpdated } from "./user"

export function handleParentQDUpdated(state, patch) {
    console.log('handleParentQDUpdated patch: ', patch)
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminParentQDUpdated(state, payload);
    }

    return handleUserParentQDUpdated(state, payload);
}